var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAkarIconsMoonFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.93 25.5418C35.27 24.7318 34.2983 24.0418 33.4833 24.4018C31.854 25.1161 30.094 25.4839 28.315 25.4818C21.34 25.4818 15.6867 19.9418 15.6867 13.1068C15.686 10.7993 16.3414 8.53914 17.5767 6.5901C18.05 5.84343 17.4817 4.8101 16.615 5.0301C9.93333 6.7351 5 12.6884 5 19.7701C5 28.1818 11.9583 35.0001 20.5433 35.0001C27.0433 35.0001 32.61 31.0918 34.93 25.5418Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0183 5.17157C25.135 4.58157 24.0817 5.6349 24.67 6.51823L25.72 8.09323C26.1464 8.73168 26.3739 9.48218 26.3739 10.2499C26.3739 11.0176 26.1464 11.7681 25.72 12.4066L24.67 13.9816C24.0817 14.8649 25.1367 15.9182 26.02 15.3282L27.5933 14.2782C28.2318 13.8519 28.9823 13.6243 29.75 13.6243C30.5177 13.6243 31.2682 13.8519 31.9067 14.2782L33.4817 15.3282C34.365 15.9182 35.4183 14.8649 34.8283 13.9816L33.7783 12.4066C33.352 11.7681 33.1244 11.0176 33.1244 10.2499C33.1244 9.48218 33.352 8.73168 33.7783 8.09323L34.8283 6.51823C35.4183 5.6349 34.365 4.58157 33.48 5.17157L31.9067 6.22157C31.2682 6.64793 30.5177 6.87549 29.75 6.87549C28.9823 6.87549 28.2318 6.64793 27.5933 6.22157L26.0183 5.17157Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsMoonFill);
export default __webpack_public_path__ + "static/media/akar-icons_moon-fill.4d5a3ebd5a877c8e1f7661b243702904.svg";
export { ForwardRef as ReactComponent };